import z from 'zod'

export const interpretationLimitationsWidgetSchema = z.object({
	series: z.array(
		z.object({
			name: z.string(),
			range: z.array(z.number().nullable()),
			type: z.enum(['correct', 'highlight']),
		})
	),
	last_price: z.number().optional().nullable(),
	plotBand: z.object({
		from: z.number().nullable(),
		to: z.number().nullable(),
	}),
})
export const interpretationElasticityWidgetSchema = z.object({
	init_price: z.number(),
	optimal_price: z.number(),
	relative_elasticity: z.string(),
	demand_curve: z.object({
		gross_profit: z.array(z.number()),
		price: z.array(z.number()),
		revenue: z.array(z.number()),
		sales_items: z.array(z.number()),
	}),
})
export const interpretationContributionWidgetSchema = z.object({
	series: z.array(
		z.object({
			name: z.string(),
			data: z.object({
				own: z.number(),
				other: z.number(),
			}),
		})
	),
})
export const interpretationGrowthDecompositionWidgetSchema = z.object({
	incremental_sales: z.number(),
	cannibalization: z.number(),
})
export const interpretationLifecycleWidgetSchema = z.object({
	lifecycle_weeks: z.number(),
})
export const interpretationDataGridWidgetSchema = z.object({
	columns: z.array(
		z.object({
			accessorKey: z.string(),
			header: z.string(),
			id: z.string(),
			meta: z.any(),
		})
	),
	data: z.array(z.any()).optional().nullable(),
})
export const interpretationStopListRulesWidgetSchema = z.array(
	z.object({
		name: z.string().nullable().optional(),
		value: z.any().nullable().optional(),
		operation: z.string().optional(),
		reference: z.string().optional(),
	})
)
export const interpretationDataSchema = z.object({
	fields: z.record(z.string(), z.string()).optional(),
	values: z.record(z.string(), z.any()).optional(),
	props: z
		.object({
			DataGrid: interpretationDataGridWidgetSchema.optional(),
			Limitations: interpretationLimitationsWidgetSchema.optional(),
			Elasticity: interpretationElasticityWidgetSchema.optional(),
			Contribution: interpretationContributionWidgetSchema.optional(),
			GrowthDecomposition:
				interpretationGrowthDecompositionWidgetSchema.optional(),
			StopListRules: interpretationStopListRulesWidgetSchema.optional(),
			Lifecycle: interpretationLifecycleWidgetSchema.optional(),
		})
		.optional(),
})

export const interpretationSchema = z.object({
	children: z.array(z.string()).nullable().optional(),
	data: interpretationDataSchema.nullable().optional(),
})
export const interpretationStepSchema = z
	.object({
		ui_group: z.union([
			z.literal('setup'),
			z.literal('price_optimization'),
			z.literal('price_adjustment'),
			z.literal('manually_changed'),
			z.literal('final_result'),
		]),
		title: z.string(),
		subtitle: z.string().nullable(),
		price_label: z.array(z.number().nullable()),
		alerts: z.array(z.string()),
	})
	.and(interpretationSchema)
